var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("connection-settings-popup", {
    attrs: {
      "is-new": _vm.isNew,
      invalid: _vm.$v.$invalid,
      "comment-id": _vm.commentId,
      resources: {
        deletePromptTitle: _vm.resource(
          "JourneyBuilder_DedupBase_Delete_Title"
        ),
        deletePromptBody: _vm.resource("JourneyBuilder_DedupBase_Delete_Body")
      }
    },
    on: {
      save: function($event) {
        return _vm.save()
      },
      delete: function($event) {
        return _vm.deleteCheckpoint()
      },
      "display-errors": function($event) {
        return _vm.displayErrors()
      },
      hidden: function($event) {
        return _vm.$emit("hidden")
      }
    },
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "w-100" },
              [
                _c("h3", { staticClass: "d-inline-block" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.resource(
                          "JourneyBuilder_DeduplicationBaseSettings_Title"
                        )
                      ) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _c("help-popover", {
                  attrs: {
                    title: _vm.resource(
                      "JourneyBuilder_DeduplicationBaseSettings_Title"
                    ),
                    content: _vm.resource(
                      "JourneyBuilder_DeduplicationBaseSettings_Description"
                    )
                  }
                }),
                _vm._v(" "),
                _vm.displayJourneyFilters
                  ? [
                      _c(
                        "div",
                        { staticClass: "mt-3" },
                        [
                          _c("h4", { staticClass: "d-inline-block mr-1" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.resource(
                                    "JourneyComposer_GenericFiltersModal_Title"
                                  )
                                ) +
                                "\n                    "
                            )
                          ]),
                          _vm._v(" "),
                          _c("help-popover", {
                            attrs: {
                              content: _vm.resource(
                                "JourneyComposer_FilterModal_GenericFiltersExplanation"
                              )
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "row form-group" }, [
                        _c("div", { staticClass: "col-12 text-center" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-primary",
                              on: {
                                click: function($event) {
                                  return _vm.openFilterSettings()
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "fas fa-pencil-alt mr-1"
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.resource(
                                      "JourneyBuilder_FilterExclusionSettings_Button_EditFilters"
                                    )
                                  )
                              )
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.filters, function(filterGroup) {
                        return [
                          _c(
                            "div",
                            {
                              key: filterGroup.id,
                              staticClass:
                                "row form-group no-gutters filter-group"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "offset-1 col-11" },
                                _vm._l(filterGroup.children, function(filter) {
                                  return _c("brick-filter-condition", {
                                    attrs: {
                                      field: filter.field,
                                      value: filter.value
                                    }
                                  })
                                }),
                                1
                              )
                            ]
                          )
                        ]
                      })
                    ]
                  : _vm._e()
              ],
              2
            )
          ]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function() {
          return [
            _c("settings-property", {
              attrs: {
                label: _vm.resource(
                  "JourneyBuilder_DeduplicationBaseSettings_Product_DisplayName"
                )
              },
              scopedSlots: _vm._u([
                {
                  key: "input",
                  fn: function() {
                    return [
                      _c("v-select", {
                        staticClass: "form-control",
                        attrs: {
                          options: _vm.productCheckOptions,
                          disabled:
                            !_vm.canWrite || !_vm.productCheckOptions.length,
                          clearable: false,
                          searchable: "",
                          filterable: ""
                        },
                        model: {
                          value: _vm.productModel,
                          callback: function($$v) {
                            _vm.productModel = $$v
                          },
                          expression: "productModel"
                        }
                      })
                    ]
                  },
                  proxy: true
                }
              ])
            }),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("h4", [
              _vm._v(
                _vm._s(
                  _vm.resource("JourneyBuilder_JourneyBrick_SettingsHeader")
                )
              )
            ]),
            _vm._v(" "),
            _c("brick-filter-settings-editor", {
              ref: "editor",
              attrs: {
                conditions: _vm.conditionsModel,
                includedCategoryFilters: ["Audience", "NotAudience"],
                idField: "id"
              },
              on: {
                "conditions-changed": function($event) {
                  _vm.conditionsModel = $event
                },
                "validation-state-changed": function($event) {
                  _vm.conditionsValid = $event
                }
              }
            }),
            _vm._v(" "),
            !_vm.$v.conditionsModel.required
              ? _c("error-message", {
                  attrs: {
                    message: _vm.resource(
                      "JourneyComposer_GroupRequired_ErrorMessage"
                    )
                  }
                })
              : _vm._e()
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }